import { useEffect, useState, useCallback } from "react";

/**
 * Hook for managing a resend cooldown timer.
 * Returns the current countdown value, whether resend is disabled, and a reset function.
 */
export function useResendCountdown(initialSeconds: number = 60) {
  const [countdown, setCountdown] = useState(initialSeconds);
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    if (!isDisabled || countdown <= 0) {
      if (countdown <= 0) setIsDisabled(false);
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown, isDisabled]);

  const reset = useCallback(() => {
    setCountdown(initialSeconds);
    setIsDisabled(true);
  }, [initialSeconds]);

  const clear = useCallback(() => {
    setCountdown(initialSeconds);
    setIsDisabled(true);
  }, [initialSeconds]);

  return { countdown, isDisabled, reset, clear };
}
